// extracted by mini-css-extract-plugin
export default {"TagLabel":"ArtifactListItem-module__TagLabel--bMULM","TagsContainer":"ArtifactListItem-module__TagsContainer--XKONC"};